import React from "react";
import styles from "./Storage.module.scss";

const Storage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <h4>Storage</h4>
      </div>
      <div className={styles.right}>
        <div className={styles.progressContainer}>
          <p>3.44GB Used</p>
          <div className={styles.progressBar}>
            <div className={styles.progress}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Storage;
